export const PLACEMENTS_4_CONSTANTS = {
  METADATA_TITLES: {},

  // Section-level (component) fields — background settings + status.
  // Background is rendered with the shared `formatBackgroundStyle` helper
  // (desktop/mobile colour, backvariant + 4 gradient stops), like programBenefits_1.
  PLACEMENTS_FIELDS_CONFIG: [
    {
      fieldName: "desktop_background_color",
      label: "Desktop Background Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter desktop background color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "mobile_background_color",
      label: "Mobile Background Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter mobile background color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "backvariant",
      label: "Background Variant",
      value: "variant_3",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select Background Variant",
      required: false,
      defaultValue: "variant_3",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Variant 1 (gradient top-left)", value: "variant_1" },
        { label: "Variant 2 (gradient bottom-right)", value: "variant_2" },
        { label: "Variant 3 (solid)", value: "variant_3" },
      ],
    },
    {
      fieldName: "gradient_color_1",
      label: "Gradient Color 1",
      value: "rgba(0, 212, 235, 0.33)",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 1",
      required: false,
      defaultValue: "rgba(0, 212, 235, 0.33)",
    },
    {
      fieldName: "gradient_color_2",
      label: "Gradient Color 2",
      value: "rgba(0, 0, 0, 0.66)",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 2",
      required: false,
      defaultValue: "rgba(0, 0, 0, 0.66)",
    },
    {
      fieldName: "gradient_color_3",
      label: "Gradient Color 3",
      value: "rgba(0, 0, 0, 0.66)",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 3",
      required: false,
      defaultValue: "rgba(0, 0, 0, 0.66)",
    },
    {
      fieldName: "gradient_color_4",
      label: "Gradient Color 4",
      value: "rgba(83, 69, 195, 0.46)",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 4",
      required: false,
      defaultValue: "rgba(83, 69, 195, 0.46)",
    },
    {
      fieldName: "status",
      label: "Placements Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Placements Section",
      defaultValue: false,
    },
  ],

  // Per-row configuration (rendered for each row in the repeater).
  ROW_FIELDS_CONFIG: [
    {
      fieldName: "scroll_frequency",
      label: "Scroll Frequency (ms per loop)",
      value: "3000",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "(e.g. 3000) — lower is faster",
      required: false,
      defaultValue: "3000",
    },
    {
      fieldName: "scroll_direction",
      label: "Scroll Direction",
      value: "left",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Direction",
      required: false,
      defaultValue: "left",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Left", value: "left" },
        { label: "Right", value: "right" },
      ],
    },
  ],

  // Icons added individually inside each row.
  ICON_FIELDS_CONFIG: [
    {
      header: "Icon / Logo",
      fieldName: "image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload icon/logo (transparent PNG/SVG recommended)",
      required: true,
    },
    {
      header: "Alt Text",
      fieldName: "alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Accessibility alt text",
      required: false,
    },
  ],
};
